import Axios, * as others from 'axios';
import React, { Component,useEffect,useState,setState  } from "react";
import './home.css';
import URL from '../../Environment';
import IMGPATHS from '../../ImgPaths';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';

// import { Helmet } from "react-helmet-async"
// import { Axios } from "axios";
// import Swiper from 'swiper';
// import 'swiper/css';
// import React from "react";
// import React, { Component } from "react";
// import { Autoplay, Pagination } from "swiper";
// import Testimonials from './Testimonials';
// import Testimonials from './Testimonials';
// import 'swiper/swiper-bundle.min.css';
// import 'swiper/swiper-bundle.min.css';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {     
      isModalOpen: false,  // เริ่มต้นเป็น false ก่อน
      popupData: null,
      isLoading: true
      // isModalOpen: true  // เปิด Modal ตอนเริ่มต้น
    };
  }

  // เพิ่ม componentDidMount เพื่อดึงข้อมูล
  componentDidMount() {
    this.fetchPopupData();
  }

  // Method สำหรับดึงข้อมูลจาก API
  fetchPopupData = async () => {
    try {
      const response = await Axios.get(URL + 'api/LandingPage/getLandingPagesDataPicture');
      const data = response.data;
      
      // ตรวจสอบว่ามีข้อมูลและมีไฟล์แนบหรือไม่
      if (data && data.attachfile) {
        this.setState({ 
          popupData: data,
          isLoading: false,
          isModalOpen: true  // เปิด modal ถ้ามีรูป
        });
      } else {
        this.setState({ 
          isLoading: false,
          isModalOpen: false
        });
      }
    } catch (error) {
      console.error('Error fetching popup data:', error);
      this.setState({ 
        isLoading: false,
        isModalOpen: false
      });
    }
  };

  render() {
    const { isModalOpen, popupData, isLoading } = this.state;

    return (
      <div>

      {/* Modal - แสดงทันทีตอนเข้าหน้าเว็บ */}
        {/* {this.state.isModalOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 modal-overlay"
            onClick={() => this.setState({ isModalOpen: false })}
          >
            <div
              style={{
                position: 'relative',
                backgroundColor: 'white',
                borderRadius: '8px',
                padding: '9px',
                maxWidth: '600px',
                maxHeight: '90vh',
                overflow: 'auto'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => this.setState({ isModalOpen: false })}
                style={{
                  position: 'absolute',
                  top: '7px',
                  right: '0px',
                  width: '15px',
                  height: '15px',
                  color: '#000000ff', //'white'
                  //backgroundColor: '#000000ff',
                  //borderRadius: '50%',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '11px',
                  padding: '0px',
                }}
              >
                ✕
              </button>

              <img
                src={`${process.env.PUBLIC_URL}/bower_components/img/queensirikit.png`}
                alt="Popup Image"
                style={{ width: '100%', height: 'auto', borderRadius: '4px' }}
              />
            </div>
          </div>
        )} */}
      
      {/* Modal - แสดงเมื่อดึงข้อมูลสำเร็จและมีรูปภาพ */}
        {!isLoading && isModalOpen && popupData && popupData.attachfile && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 modal-overlay"
            onClick={() => this.setState({ isModalOpen: false })}
          >
            <div
              style={{
                position: 'relative',
                backgroundColor: 'white',
                borderRadius: '8px',
                padding: '9px',
                maxWidth: '600px',
                maxHeight: '90vh',
                overflow: 'auto'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => this.setState({ isModalOpen: false })}
                style={{
                  position: 'absolute',
                  top: '7px',
                  right: '0px',
                  width: '15px',
                  height: '15px',
                  color: '#000000ff',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '11px',
                  padding: '0px',
                  zIndex: 10
                }}
              >
                ✕
              </button>

              {/* แสดง topic ถ้ามี */}
              {/* {popupData.topic && (
                <h3 style={{ 
                  marginBottom: '10px', 
                  textAlign: 'center',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  paddingTop: '5px'
                }}>
                  {popupData.topic}
                </h3>
              )} */}

              <img
                src={`${IMGPATHS}img/LandingPage/${popupData.attachfile}`}
                alt={popupData.topic || "Popup Image"}
                style={{ width: '100%', height: 'auto', borderRadius: '4px' }}
                onError={(e) => {
                  console.error('Image failed to load');
                  e.target.style.display = 'none';
                }}
              />
            </div>
          </div>
        )}


      {/* Meta Tags for SEO */}
      {/* <Helmet>
        <title>สหกรณ์ออมทรัพย์ไทยออยล์ - บริการทางการเงินที่มั่นคง</title>
        <meta
          name="description"
          content="สหกรณ์ออมทรัพย์ไทยออยล์ให้บริการทางการเงินที่มั่นคง รวมถึงเงินกู้ เงินฝาก และข้อมูลสมาชิกออนไลน์"
        />
        <meta
          name="keywords"
          content="สหกรณ์ออมทรัพย์, ไทยออยล์, เงินกู้, เงินฝาก, ออนไลน์"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="สหกรณ์ออมทรัพย์ไทยออยล์" />
        <meta property="og:title" content="สหกรณ์ออมทรัพย์ไทยออยล์ - บริการทางการเงิน" />
        <meta
          property="og:description"
          content="สหกรณ์ออมทรัพย์ไทยออยล์ให้บริการทางการเงินที่มั่นคงและน่าเชื่อถือสำหรับสมาชิก"
        />
        <meta property="og:image" content="%PUBLIC_URL%/logo192.png" />
        <meta property="og:url" content="https://savings-cooperative.thaioilgroup.com/WebsiteSavingsCoop/home" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://savings-cooperative.thaioilgroup.com/WebsiteSavingsCoop/home" />
      </Helmet> */}

      {/* Schema Markup */}
      {/* <script type="application/ld+json">{`
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "สหกรณ์ออมทรัพย์ไทยออยล์",
          "url": "https://savings-cooperative.thaioilgroup.com/WebsiteSavingsCoop/home",
          "logo": "https://savings-cooperative.thaioilgroup.com/WebsiteSavingsCoop/home/logo192.png",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "038-359000",
            "contactType": "customer service",
            "language": "TH"
          }
        }
      `}
      </script> */}


        {/* Contact Section */}
        <section id="contact" className="contact section">
          <div className="container section-title" >
          {/* <h2 style={{fontFamily:'Thai Sans Lite'}}>สหกรณ์ออมทรัพย์ไทยออยล์ จำกัด</h2> */}
          <a target href="#" title="สหกรณ์ออมทรัพย์ไทยออยล์">
                <img style={{maxWidth: '100%'}} src={`${process.env.PUBLIC_URL}/bower_components/img/LOGOCooperativeTOP8.png`} alt="โลโก้สหกรณ์ออมทรัพย์ไทยออยล์" loading="lazy"/>
              </a>

            {/* <div className="image-container" >
              <a className="logo d-flex align-items-center me-auto me-xl-0">
                <img src="/bower_components/img/LOGOCooperativeTOP8.png" data-at2x="/bower_components/img/LOGOCooperativeTOP8.png" style={{maxWidth: '50%'}} />
              </a>
            </div> */}
          </div>
          {/* End Section Title */}
          <div className="mb-5" >
            <div className="image-container">
              <a target href="#">
                <img style={{maxWidth: '100%'}} src={`${process.env.PUBLIC_URL}/bower_components/img/Board/20180531160049yAGIVjJ-7.png`} alt="ภาพประชาสัมพันธ์สหกรณ์ออมทรัพย์ไทยออยล์" loading="lazy"/>
              </a>
            </div>
          </div>
        </section>

        {/* <section id="contact" className="contact section">
          <div className="container">
            <div className="row coop" style={{marginTop: 160,display: "flex", justifyContent: "center"}}>
              <div className="col-md-10 col-md-offset-1 col-xs-10 col-xs-offset-1 p-side">
                <div className="row flex-box services-with-bg mt-minus">
                  <div className="col-md-4 service-center-icon white text-center">
                    <i className="cws-icon flaticon-lights7 mb-20" />
                    <h3 className="mt-0 mb-0">คำร้องออนไลน์</h3>
                    <div className="divider mt-10 mb-5 gray-darknest mini" />
                    <p className="mb-30">คำร้องออนไลน์</p>
                    <a href="https://savingscoop.thaioilgroup.com/savingscoop/Home/" className="cws-button small" title="ยื่นคำร้องออนไลน์">เข้าสู่ระบบ</a>
                  </div>
                  <div className="col-md-4 service-center-icon color-4 text-center">
                    <i className="cws-icon flaticon-mug16 text-white mb-20" />
                    <h3 className="mt-0 mb-0 text-white">คำขอกู้ออนไลน์</h3>
                    <div className="divider mt-10 mb-5 white mini" />
                    <p className="text-white mb-30">ระบบคำขอกู้ออนไลน์</p>
                    <a href="https://savingscoop.thaioilgroup.com/savingscoop/Home/" className="cws-button white color-4 small" title="ยื่นคำขอกู้เงินออนไลน์">เข้าสู่ระบบ</a>
                  </div>
                  <div className="col-md-4 service-center-icon text-center">
                    <i className="cws-icon flaticon-diamond7 text-white mb-20" />
                    <h3 className="mt-0 mb-0 text-white">ข้อมูลสมาชิกออนไลน์</h3>
                    <div className="divider mt-10 mb-5 white mini" />
                    <p className="text-white mb-30">ระบบข้อมูลสมาชิกออนไลน์</p>
                    <a href="https://savingscoop.thaioilgroup.com/savingscoop/Home/" className="cws-button white small" title="ตรวจสอบข้อมูลสมาชิก">เข้าสู่ระบบ</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        
        <br />

         {<CoopSwiper/>}

        <section id="features" className="features section">
          <div className="container">
            <ul className="nav nav-tabs row gy-4 d-flex">
              <li className="nav-item col-6 col-md-4 col-lg-2">
                <a className="nav-link" target='_blank' href="regulation" title="ระเบียบข้อบังคับสหกรณ์ออมทรัพย์ไทยออยล์">
                  <i className="bi bi-binoculars" style={{color: '#0dcaf0'}} />
                  <h4>ระเบียบข้อบังคับสหกรณ์ฯ</h4>
                </a>
              </li>{/* End Tab 1 Nav */}
              <li className="nav-item col-6 col-md-4 col-lg-2">
                <a className="nav-link" target='_blank' href="calendar" title="ตารางปฏิทินประจำปีสหกรณ์">
                  <i className="bi bi-box-seam" style={{color: '#6610f2'}} />
                  <h4>ตารางปฏิทินประจำปี</h4>
                </a>
              </li>{/* End Tab 2 Nav */}
              <li className="nav-item col-6 col-md-4 col-lg-2">
                <a className="nav-link" target='_blank' href="policy" title="นโยบายสหกรณ์ออมทรัพย์ไทยออยล์">
                  <i className="bi bi-brightness-high" style={{color: '#20c997'}} />
                  <h4>นโยบายสหกรณ์ฯ</h4>
                </a>
              </li>{/* End Tab 3 Nav */}
              <li className="nav-item col-6 col-md-4 col-lg-2">
                <a className="nav-link" target='_blank' href="enactment" title="พระราชบัญญัติสหกรณ์/กฎกระทรวง">
                  <i className="bi bi-command" style={{color: '#df1529'}} />
                  <h4>พระราชบัญญัติสหกรณ์ / กฎกระทรวง</h4>
                </a>
              </li>{/* End Tab 4 Nav */}
              <li className="nav-item col-6 col-md-4 col-lg-2">
                <a className="nav-link" target='_blank' href="yearlyreport" title="รายงานประจำปีสหกรณ์">
                  <i className="bi bi-easel" style={{color: '#0d6efd'}} />
                  <h4>รายงานประจำปี</h4>
                </a>
              </li>{/* End Tab 5 Nav */}
              <li className="nav-item col-6 col-md-4 col-lg-2">
                <a className="nav-link" target='_blank' href="linktoother" title="Link หน่วยงานราชการที่เกี่ยวข้อง">
                  <i className="bi bi-map" style={{color: '#fd7e14'}} />
                  <h4 style={{textAlign:'center'}}>Link หน่วยงานราชการที่เกี่ยวข้อง</h4>
                </a>
              </li>{/* End Tab 6 Nav */}
            </ul>
          </div>
        </section>

        <br/>
        <section id="pricing" className="pricing section">
          <div className="container section-title">
            <h2>ตารางอัตราดอกเบี้ย</h2>
          </div>

            <div class="container">
            <div class="row gy-4">
            {<GetDataInterestLoan />}
            {<GetDataInterestHome />}
            {<GetDataInterestDeposit />}
          </div>
          </div>
        </section>

        <div className="add-on-container">
          <div className="container">
            <div className="row">
              <div className="col-md-3">
                <a className="clink" href="manual" title="คู่มือสมาชิกสหกรณ์ออมทรัพย์ไทยออยล์">
                  <span className="cicon"><i className="fa fa-book" /></span>
                  <span className="detail">คู่มือสมาชิก</span>
                </a>
              </div>
              <div className="col-md-3">
                <a className="clink" href="calculatedividend" title="วิธีการคำนวณเงินปันผล">
                  <span className="cicon"><i className="fa fa-star" /></span>
                  <span className="detail">วิธีการคำนวนเงินปันผล</span>
                </a>
              </div>
              <div className="col-md-3">
                <a className="clink" href="bank" title="ช่องทางการชำระเงิน">
                  <span className="cicon"><i className="fa fa-paper-plane" /></span>
                  <span className="detail">ช่องทางการชำระเงิน</span>
                </a>
              </div>
              <div className="col-md-3">
                <a className="clink fancybox-contact fancybox.ajax" href="withdrawatm" title="ขั้นตอนกู้ฉุกเฉินสหกรณ์ผ่าน App/ATM">
                  <span className="cicon"><i className="fa fa-clipboard" /></span>
                  <span className="detail">ขั้นตอนกู้ฉุกเฉินสหกรณ์ผ่าน <br/>App / ATM</span>
                </a>
              </div>
              <div className="col-md-3">
                <a className="clink fancybox-contact fancybox.ajax" href="contactus">
                  <span className="cicon"><i className="fa fa-comments" title="ติดต่อสหกรณ์ออมทรัพย์ไทยออยล์"/></span>
                  <span className="detail">ติดต่อเรา</span>
                </a>
              </div>
              <div className="col-md-3">
                <a className="clink fancybox-contact fancybox.ajax" href="https://savings-cooperative.thaioilgroup.com/websiteadmin">
                  <span className="cicon"><i className="fa fa-user" /></span>
                  <span className="detail">เข้าสู่ระบบ Admin <br/>(เฉพาะเจ้าหน้าที่)</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="row">
            <div className="col-xs-12">
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 text-center">
              <h4 style={{fontSize:'20px'}}>สหกรณ์ออมทรัพย์ไทยออยล์ จำกัด</h4>
              <h4 style={{fontSize:'20px'}}>42/1 กม.124 ม.1 ถนนสุขุมวิท ต.ทุ่งสุขลา อ.ศรีราชา จ.ชลบุรี 20230</h4>
              <p style={{fontSize:'20px'}}>Line ID : coop59</p>
              <a
                href="https://line.me/ti/p/coop59"
                title="Line สหกรณ์ออมทรัพย์ไทยออยล์"
              ></a>
              <img src={`${process.env.PUBLIC_URL}/bower_components/img/Board/linecoop.png`} width={200} alt="QR Code Line สหกรณ์ออมทรัพย์ไทยออยล์" loading="lazy" />
              <h4 style={{fontSize:'20px'}}>สงวนลิขสิทธิ์ พ.ศ.2562 สหกรณ์ออมทรัพย์ไทยออยล์ © 2019 Thaioil Cooperative Savinvgs</h4>
              <h4 style={{fontSize:'20px'}}>คำแนะนำการใช้เว็บไซต์ : แสดงผลได้ดีกับ Chrome , Firefox</h4>
            </div>
          </div>
        </div>

      </div>

    )
  }
}

function GetDataInterestLoan() {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lblloan, setLoanDate] = useState(null);

  useEffect(() => {

  const fetchData = async () => {

      Axios.get(URL + 'api/Home/GetDataInterestLoan').then((response) => {
        const res = response.data;
        if (Array.isArray(response.data.data)) {
          setData(response.data.data);
          
        } else {
          //console.error('Response data is not an array', response.data.data);
          setError('Data is not in the expected array format');
        }
        setLoading(false);   
    
    
      }).catch((error) => {
        //alert('error');
        //console.log(error);
        setError(error);
        setLoading(false); 
    
      });
  };

  const fetchData2 = async () => {
    
    const data = 
    {
      loantype: 'interest_loan',
    };

      Axios.post(URL + 'api/Home/GetDataInterestUpdateDate',data,{
        headers: {
          "Content-Type": "application/json",
        },
      }).then((response) => {
        
        setLoanDate(response.data.updateddate);
        setLoading(false); 
    
      }).catch((error) => {
        //console.log(error);
        setError(error);
        setLoading(false); 
    
      });
  };

  // เรียกใช้งาน fetchData เมื่อค่าตัวแปร count มีการเปลี่ยนแปลง
  fetchData();
  fetchData2();
  // Cleanup function ที่จะถูกเรียกเมื่อ component ถูก unmount
  return () => {
    // ทำการคืนการทำงานที่ต้องการ (cleanup)
    //console.log('Component unmounted');
  };

  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (

              <div className="col-lg-4">
                <div className="pricing-item featured">
                  <div className="pricing-header" style={{backgroundColor: '#28a6ec', borderColor: '#28a6ec'}}>
                  <h3>ตารางอัตราดอกเบี้ยเงินกู้</h3>
                  </div>
                  <ul style={{textAlign: 'left'}}>
                  <li><span style={{textAlign: 'left'}}>ประเภทเงินกู้</span><span style={{float: 'right'}}>ดอกเบี้ย (ต่อปี)</span></li>
                    {Array.isArray(data) && data.length > 0 ? (
                    data.map((item, index) => (
                      <li  key={item.id}>
                        <span style={{textAlign: 'left'}}>{item.loantype}</span>
                        <span style={{float: 'right'}}>{Number(item.interest).toFixed(2)}%</span>
                      </li>
                    ))) : (
                      <li><span style={{textAlign: 'left'}}>ไม่มีข้อมูล</span></li>
                    )}
                    <li><span style={{textAlign: 'center', color: 'red'}}>{lblloan}</span></li>
                  </ul>
                </div>
              </div>

  );
}

function GetDataInterestDeposit() {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lblloan, setLoanDate] = useState(null);

  useEffect(() => {

  const fetchData = async () => {

      Axios.get(URL + 'api/Home/GetDataInterestDeposit').then((response) => {
        const res = response.data;
        if (Array.isArray(response.data.data)) {
          setData(response.data.data);
        } else {
          //console.error('Response data is not an array', response.data.data);
          setError('Data is not in the expected array format');
        }
        setLoading(false);   
    
    
      }).catch((error) => {
        //alert('error');
        //console.log(error);
        setError(error);
        setLoading(false); 
    
      });
  };

  const fetchData2 = async () => {
    
    const data = 
    {
      loantype: 'interest_deposit',
    };

      Axios.post(URL + 'api/Home/GetDataInterestUpdateDate',data).then((response) => {
        setLoanDate(response.data.updateddate);
        setLoading(false);
    
      }).catch((error) => {
        console.log(error);
        setError(error);
        setLoading(false); 
    
      });
  };

  // เรียกใช้งาน fetchData เมื่อค่าตัวแปร count มีการเปลี่ยนแปลง
  fetchData();
  fetchData2();
  // Cleanup function ที่จะถูกเรียกเมื่อ component ถูก unmount
  return () => {
    // ทำการคืนการทำงานที่ต้องการ (cleanup)
    //console.log('Component unmounted');
  };

  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (

<div className="col-lg-4">
<div className="pricing-item featured">
  <div className="pricing-header" style={{backgroundColor: '#f9b91e', borderColor: '#f9b91e!important'}}>
  <h3>ตารางอัตราดอกเบี้ยเงินฝาก</h3>
  </div>
  <ul style={{textAlign: 'left'}}>
  <li><span style={{textAlign: 'left'}}>ประเภทเงินฝาก</span><span style={{textAlign: 'right',float:'right'}}>ดอกเบี้ย (ต่อปี)</span></li>
                    {Array.isArray(data) && data.length > 0 ? (
                    data.map((item, index) => (
                      <li  key={item.id}>
                        <span style={{textAlign: 'left'}}>{item.DepositType}</span>
                        <span style={{float: 'right'}}>{Number(item.interest).toFixed(2)}%</span>
                      </li>
                    ))) : (
                      <li><span style={{textAlign: 'left'}}>ไม่มีข้อมูล</span></li>
                    )}
                    <li><span style={{textAlign: 'center', color: 'red'}}>{lblloan}</span></li>
  </ul>
</div>
</div>

  );
}

function GetDataInterestHome() {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lblloan, setLoanDate] = useState(null);

  useEffect(() => {

  const fetchData = async () => {
    // try {

      Axios.get(URL + 'api/Home/GetDataInterestHome').then((response) => {
        const res = response.data;
        if (Array.isArray(response.data.data)) {
          setData(response.data.data);
        } else {
          //console.error('Response data is not an array', response.data.data);
          setError('Data is not in the expected array format');
        }
        setLoading(false);   
    
    
      }).catch((error) => {
        //alert('error');
        //console.log(error);
        setError(error);
        setLoading(false); 
    
      });
  };

  const fetchData2 = async () => {
    
    const data = 
    {
      loantype: 'interest_Home',
    };

      Axios.post(URL + 'api/Home/GetDataInterestUpdateDate',data).then((response) => {
        setLoanDate(response.data.updateddate);
        setLoading(false);
    
      }).catch((error) => {
        console.log(error);
        setError(error);
        setLoading(false); 
    
      });
  };

  // เรียกใช้งาน fetchData เมื่อค่าตัวแปร count มีการเปลี่ยนแปลง
  fetchData();
  fetchData2();
  // Cleanup function ที่จะถูกเรียกเมื่อ component ถูก unmount
  return () => {
    // ทำการคืนการทำงานที่ต้องการ (cleanup)
    //console.log('Component unmounted');
  };

  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (

<div className="col-lg-4">
<div className="pricing-item featured" >
  <div className="pricing-header" style={{backgroundColor: '#F56363', borderColor: '#F56363'}}>
  <h3>ตารางอัตราดอกเบี้ยเคหฯ<br />ไทยออยล์</h3>
  </div>
  <ul>
  <li><span style={{textAlign: 'left'}}>วงเงินกู้</span><span style={{float: 'right'}}>ดอกเบี้ย (ต่อปี)</span></li>
                    {Array.isArray(data) && data.length > 0 ? (
                    data.map((item, index) => (
                      <li key={item.id}>
                        <span style={{textAlign: 'left'}}>{item.LoanLimit}</span>
                        <span style={{float: 'right'}}>{Number(item.interest).toFixed(2)}%</span>
                      </li>
                    ))) : (
                      <li><span style={{textAlign: 'left'}}>ไม่มีข้อมูล</span></li>
                    )}
                    <li><span style={{textAlign: 'center', color: 'red'}}>{lblloan}</span></li>
  </ul>
</div>
</div>
  );
}


const CoopSwiper = () => {

  const [CoopSwiperData, setCoopSwiperData] = useState([]);
  const [CoopSwiperLoan, setCoopSwiperLoading] = useState(true);
  const [errorCoopSwiper, setCoopSwiperError] = useState(null);

  useEffect(() => {

    const fetchCoopSwiperData = async () => {

          Axios.get(URL + `api/Home/GetCoopSwipers`).then((response) => {
            const res = response.data;
            //console.log("CoopSwiper",res);
    
            setCoopSwiperData(response.data);
            setCoopSwiperLoading(false);   
    
          }).catch((error) => {
            setCoopSwiperError(error);
            setCoopSwiperLoading(false); 
    
          });
      };
    
      // เรียกใช้งาน fetchData เมื่อค่าตัวแปร count มีการเปลี่ยนแปลง
      fetchCoopSwiperData();

      // Cleanup function ที่จะถูกเรียกเมื่อ component ถูก unmount
      return () => {
        // ทำการคืนการทำงานที่ต้องการ (cleanup)
        //console.log('Component unmounted');
      };

  }, []);

  if (CoopSwiperLoan) {
      return <div>Loading...</div>;
  }

  if (errorCoopSwiper) {
      return <div>Error: {errorCoopSwiper.message}</div>;
  }

  return (
    <section id="testimonials" className="testimonials section dark-background">
      <div className="container section-title">
        <h2>ประชาสัมพันธ์</h2>
      </div>

      <img
        src={`${process.env.PUBLIC_URL}/bower_components/assets/img/building.jpg`}
        className="testimonials-bg"
        alt=""
      />

      <div className="container">

          <Swiper
            modules={[Autoplay, Pagination]}
            loop={true}
            speed={600}
            autoplay={{ delay: 5000 }}
            slidesPerView="auto"
            pagination={{ clickable: true }}
            className="init-swiper"
            >
              {
                CoopSwiperData.map((swp) => (

                  <SwiperSlide key={swp.id}>
                  <div className="testimonial-item" >
                    <img
                      src={`${IMGPATHS}/img/Slide/${swp.filename}`}
                      className="testimonial-img"
                      alt="" 
                      style={{
                        height: '480px',
                        width: 'auto',
                        objectFit: 'contain' // หรือ 'cover' ขึ้นอยู่กับผลลัพธ์ที่ต้องการ
                      }}
                    />
                  </div>
                  </SwiperSlide>

                  ))
                }
        </Swiper> 
        
      </div>
    </section>
  );
};

export default Home;
